<template>
  <div>

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5>
            <p class="table_card__head--title">Notificaciones</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                class="breadcums__option"
                @click="$router.push({name: 'notification'})"
              >
                Historial de notificaciones
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                class="breadcums__option"
                disabled
              >
                Nueva notificación
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <button
              type="button"
              class="faccess_button px-5"
              @click="sendMessage()"
              :disabled="!valid || notification.attributes.title == '' || notification.attributes.message == ''"
            >
              Crear
            </button>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
              <v-layout
                row
                wrap
                style="background-color: #fff; padding: 0px;">
              <v-flex
                xs6
                style="padding: 20px">
                <v-text-field
                  v-model="notification.attributes.title"
                  label="Título"
                  required
                  placeholder="Máximo 200 caracteres"
                  :rules="[rules.required, rules.title]"
                  counter="200"></v-text-field>
              </v-flex>
              <v-flex
                xs6
                style="padding: 20px">
                <v-text-field
                  v-model="notification.attributes.message"
                  label="Mensaje"
                  required
                  placeholder="Máximo 250 caracteres"
                  :rules="[rules.required, rules.message]"
                  counter="250"></v-text-field>
              </v-flex>
            </v-layout>
            </v-form>
          </v-flex>

          <v-flex
            xs6
            style="padding: 20px">
            <label for="selected" style="color: #89899B; font-size: 12px;">Notificación dirigida a: </label>
            <v-select
              :items="notification_selector"
              v-model="selected"
              single-line
            ></v-select>
          </v-flex>
          <v-flex
            xs6
            style="padding: 20px">
            <div v-if="selected != 'Todos los usuarios'">
              <label for="selected" style="color: #89899B; font-size: 12px;">Selección de usuarios: </label>
              <v-dialog
                ref="users"
                v-model="modal3"
                persistent
                lazy
                full-width
                width="80%">
                <button
                  type="button"
                  class="faccess_button shadow"
                  slot="activator"
                >
                  <v-icon color="#FFF" class="mr-2">group_add</v-icon>
                  Seleccionar usuarios
                </button>
                <div class="clearfix"></div>
                <v-checkbox
                  style="padding: 0px !important; margin: 0px !important; margin-top: 15px; margin-bottom: -12px;"
                  :label="user.name+' | '+user.email"
                  v-model="users[index]"
                  v-for="(user, index) in users"
                  v-if="!modal3"
                  slot="activator"
                  color="#1476FB"
                  disabled></v-checkbox>
                <v-card class="table_card">
                  <v-card-title class="table_card__head pb-4 pt-4">
                    <h5 class="table_card__head--title">Seleccione los usuarios</h5>
                    <v-spacer></v-spacer>
                    <v-flex class="right">
                      <input
                        type="text"
                        placeholder="Buscar"
                        class="input_solid"
                        v-model="options_table.search"
                      >
                      <img
                        src="@/assets/img/icons/search-icon.svg"
                        class="button_search"
                      >
                    </v-flex>

                  </v-card-title>
                  <v-data-table
                    v-model="users"
                    :headers="options_table.headers_table"
                    :items="filteredUsers"
                    :search="options_table.search"
                    :pagination.sync="options_table.pagination"
                    select-all
                  >
                    <template slot="headers" slot-scope="props">
                      <tr >
                        <th>
                          <v-icon>filter_list</v-icon>
                        </th>
                        <th
                          v-for="header in options_table.headers_table"
                          :key="header.text"
                        >
                          <div v-if="options_table.filters.hasOwnProperty(header.value)">
                            <v-select flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="options_table.filters[header.value]" :placeholder="header.text">
                            </v-select>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <v-checkbox
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.native="toggleAll"
                            color="#1476FB"
                          ></v-checkbox>
                        </th>
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header.value)"
                        >
                          <v-icon small>arrow_upward</v-icon>
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                      <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td>
                          <v-checkbox
                            :input-value="props.selected"
                            primary
                            hide-details
                            color="#1476FB"
                          ></v-checkbox>
                        </td>
                        <td class="text-xs-center email">{{ props.item.email }}</td>
                        <td class="text-xs-center">{{ props.item.name }}</td>
                        <td class="text-xs-center">{{ props.item.mobile }}</td>
                        <td class="text-xs-center">{{ props.item.gender }}</td>
                        <td class="text-xs-center">{{ props.item.age }}</td>
                        <td class="text-xs-center">{{ props.item.location_name }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-divider></v-divider>
                  <v-card-actions style="justify-content: flex-end" class="px-3 table_card__footer">
                    <v-btn
                      flat
                      color="#89899B"
                      class="py-4"
                      @click="modal3 = false; users = [];"
                    >CANCELAR</v-btn>

                      <button
                        type="button"
                        @click="modal3 = false;"
                        class="faccess_button px-5 ml-4 mr-3"
                      >Aceptar</button>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

          </v-flex>
          <v-flex xs12>
            <v-switch
              style="padding: 20px"
              :label="'Enviar de inmediato'"
              v-model="right_now"
              color="#1476FB"
            >
            </v-switch>
          </v-flex>
          <v-flex
            xs6
            style="padding: 20px"
            v-if="!right_now">
            <v-dialog
              ref="datepicker"
              v-model="modal"
              :return-value.sync="date"
              persistent
              lazy
              full-width
              width="290px">
              <v-text-field
                slot="activator"
                v-model="date"
                label="Fecha de envío"
                placeholder="00/00/0000"
                readonly></v-text-field>
              <v-date-picker
                v-model="date"
                scrollable
                color="#EC7E00"
                locale="es">
                <v-spacer></v-spacer>
                <v-btn flat color="#EC7E00" dark @click="modal = false">Cancelar</v-btn>
                <v-btn flat color="#EC7E00" dark @click="$refs.datepicker.save(date)">Aceptar</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex
            xs6
            style="padding: 20px"
            v-if="!right_now">
            <v-dialog
              ref="timepicker"
              v-model="modal2"
              :return-value.sync="time"
              persistent
              lazy
              full-width
              width="290px">
              <v-text-field
                slot="activator"
                v-model="time"
                label="Hora de envío"
                placeholder="00:00"
                readonly
              ></v-text-field>
              <v-time-picker
                v-model="time"
                actions
                color="#EC7E00">
                <v-spacer></v-spacer>
                <v-btn flat color="#EC7E00" dark @click="modal2 = false">Cancelar</v-btn>
                <v-btn flat color="#EC7E00" dark @click="$refs.timepicker.save(time)">Aceptar</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          type="button"
          class="faccess_button px-5"
          @click="sendMessage()"
          :disabled="!valid || notification.attributes.title == '' || notification.attributes.message == ''"
        >
          Crear
        </button>
      </div>
    </div>


  </div>

</template>

<script>
export default {
  data(){
    return{
      selected: 'Todos los usuarios',
      notification_selector: ['Todos los usuarios', 'Varios usuarios'],
      notification: {
        attributes: {
          title: '',
          message: '',
          users: [],
          send_date_time: '',
          gmt: '',
          company_id: 0
        }
      },
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'Correo electrónico',
            align: 'center',
            value: 'email'
          },
          {
            text: 'Nombre',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Móvil',
            align: 'center',
            value: 'mobile'
          },
          {
            text: 'Género',
            align: 'center',
            value: 'gender'
          },
          {
            text: 'Edad',
            align: 'center',
            value: 'age'
          },
          {
            text: 'Sede',
            align: 'center',
            value: 'location_name'
          },
        ],
        filters: {
          gender: [],
          location_name: [],
          age: []
        },
      },
      date: null,
      time: null,
      modal: false,
      modal2: false,
      modal3: false,
      users: [],
      users_for_select:[],
      right_now: true,
      rules: {
          required: value => !!value || 'Required.',
          title: value => value.length <= 200 || 'Maximo 45 caracteres',
          message: value => value.length <= 250 || 'Maximo 90 caracteres',
      },
      valid: false
    }
  },
  mounted() {
  },
  computed: {
    filteredUsers() {
      return this.users_for_select.filter(d => {
        return Object.keys(this.options_table.filters).every(f => {
          return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
        })
      })
    }
  },
  methods: {
    toggleAll () {
      var vm = this;
      var emails = document.querySelectorAll("table.v-datatable td.email");
      var check = document.querySelector(".v-table thead [aria-checked]").getAttribute("aria-checked");
      if (check=="false") {
        emails.forEach(function(element) {
          vm.users.splice(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML )),1);
        });
      }else{
        emails.forEach(function(element) {
          if(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML ))==-1){
            vm.users.push(vm.filteredUsers.find( user => user.email === element.innerHTML ));
          }
        });
      }
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    columnValueList(val) {
      return this.users_for_select.map(d => d[val])
    },
    getClients(){
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('app/users/clients',{data:this.encrypt(data).toString()},
        {
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
           this.users_for_select = response.body.data;
           if(response.body.meta != undefined && response.body.meta != null){
             if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
               this.checkToken(response.body.meta.authentication_token)
             }
           }
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        };
      }
    },
    sendMessage(){
      if(this.right_now){
        this.notification.attributes.send_date_time = ''
        this.notification.attributes.gmt = ''
      }else{
        this.notification.attributes.send_date_time = this.date.replace(/-/g,'/') + ' ' + this.time
        var date = new Date(this.notification.attributes.send_date_time)
        this.notification.attributes.gmt = Number(this.$moment(date).format('ZZ'))/100
      }
      var send_emails=[];
      if(this.selected == "Todos los usuarios"){
        this.notification.attributes.users = []
      }else{
        this.notification.attributes.users = this.users.map(function(x) { return {'id': x.id, 'email': x.email} });
      }

      this.notification.attributes.company_id = this.getCompany().id;

      try {
        this.$http.post('push_messages/push_notification',{
          data: this.encrypt(this.notification).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
          this.$router.push({name: 'notification'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        alert(e.message)
      }
    }
  },
  watch: {
    selected: function (val) {
      if(val=="Varios usuarios" && (this.users_for_select == [] || this.users_for_select == "")){
        this.getClients();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/notifications/New_notification.vue